module.exports = __webpack_public_path__ + "037b8237a2e2e4e7633b59a7a5fc3fac.svg";